
// class MediaGallery extends HTMLElement {
//   constructor() {
//     super();
    
//     this.viewer = this.querySelector('#gallery-viewer');
//     this.thumbnails = this.querySelectorAll('.media-thumbs__btn');
//     this.viewerItems = this.querySelectorAll('.media-viewer__item');
//     this.prevBtn = this.querySelector('[name="prev"]');
//     this.nextBtn = this.querySelector('[name="next"]');
//     this.currentCounter = this.querySelector('.media-ctrl__current-item');
//     this.layout = this.dataset.layout;
    
//     this.currentIndex = 0;
//     this.visibleItems = Array.from(this.viewerItems).filter(item => 
//       !item.classList.contains('media-viewer__item--variant')
//     );
    
//     // console.log('=== MEDIA GALLERY DEBUG ===');
//     // console.log('Total viewer items:', this.viewerItems.length);
//     // console.log('Visible items:', this.visibleItems.length);
//     // console.log('Thumbnails:', this.thumbnails.length);
    
//     this.init();
//   }
  
//   init() {
//     // Delay storage to ensure page is fully loaded
//     setTimeout(() => {
//       this.storeOriginalImages();
//     }, 500);
    
//     setTimeout(() => {
//       this.setupInkyBayDetection();
//     }, 1000);
    
//     this.setupThumbnailClicks();
//     this.setupArrowClicks();
//     this.setupKeyboardNavigation();
//     this.updateActiveStates();
//   }
  
//   /**
//    * Store original images - WITH DETAILED LOGGING
//    */
//   storeOriginalImages() {
//     // console.log('\n=== STORING ORIGINAL IMAGES ===');
    
//     this.viewerItems.forEach((item, itemIndex) => {
//       const mediaId = item.dataset.mediaId;
//       const mediaType = item.dataset.mediaType;
      
//       // console.log(`\nItem ${itemIndex + 1}:`);
//       // console.log('  Media ID:', mediaId);
//       // console.log('  Media Type:', mediaType);
      
//       // Find the main product image
//       const productImage = item.querySelector('img.product-image');
      
//       if (productImage) {
//         const src = productImage.getAttribute('src');
//         const srcset = productImage.getAttribute('srcset');
//         const dataSrc = productImage.getAttribute('data-src');
        
//         // console.log('  Main Image Found:');
//         // console.log('    src:', src ? src.substring(0, 80) + '...' : 'NONE');
//         // console.log('    srcset:', srcset ? 'YES (' + srcset.length + ' chars)' : 'NONE');
//         // console.log('    data-src:', dataSrc ? dataSrc.substring(0, 80) + '...' : 'NONE');
        
//         // Store with direct reference to the image element
//         if (!this.originalGallerySources) {
//           this.originalGallerySources = new Map();
//         }
        
//         this.originalGallerySources.set(mediaId, {
//           itemElement: item,
//           imageElement: productImage,
//           src: src,
//           srcset: srcset,
//           dataSrc: dataSrc
//         });
        
//         // console.log('  ✓ STORED for media ID:', mediaId);
//       } else {
//         // console.log('  ✗ NO product-image found');
//       }
//     });
    
//     // console.log('\n=== STORAGE COMPLETE ===');
//     // console.log('Total items stored:', this.originalGallerySources ? this.originalGallerySources.size : 0);
//   }
  
//   /**
//    * Setup InkyBay detection
//    */
//   setupInkyBayDetection() {
//     const inkybayCard = document.querySelector('#INKYBAY_COLOR_CARD');
//     if (inkybayCard) {
//       // console.log('\n✓ InkyBay detected');
//       this.attachInkyBayListeners();
//     } else {
//       // console.log('\n✗ InkyBay NOT detected');
//     }
//   }
  
//   /**
//    * Attach InkyBay listeners
//    */
//   attachInkyBayListeners() {
//     const colorSwatches = document.querySelectorAll('.inkybay_default_color_swatch_cover');
    
//     colorSwatches.forEach(swatch => {
//       swatch.addEventListener('click', () => {
//         const colorName = swatch.querySelector('.inkybay_default_color_swatch_title')?.textContent;
//         // console.log('\n🎨 INKYBAY COLOR CLICKED:', colorName);
//       });
//     });
    
//     // console.log(`Attached to ${colorSwatches.length} color swatches`);
//   }
  
//   /**
//    * Setup thumbnail clicks
//    */
//   setupThumbnailClicks() {
//     // console.log('\n=== SETTING UP THUMBNAILS ===');
    
//     this.thumbnails.forEach((thumb, index) => {
//       const thumbItem = thumb.closest('.media-thumbs__item');
//       const mediaId = thumbItem ? thumbItem.dataset.mediaId : 'UNKNOWN';
      
//       // console.log(`Thumbnail ${index + 1}: Media ID = ${mediaId}`);
      
//       thumb.addEventListener('click', (e) => {
//         e.preventDefault();
        
//         // console.log('\n🖼️ ========================================');
//         // console.log('GALLERY THUMBNAIL CLICKED!');
//         // console.log('Thumbnail index:', index);
//         // console.log('Media ID:', mediaId);
//         // console.log('========================================');
        
//         this.changeMediaToGallery(mediaId, index);
//       });
//     });
//   }
  
//   /**
//    * Change to gallery image
//    */
//   changeMediaToGallery(mediaId, thumbIndex = null) {
//     // console.log('\n--- CHANGE MEDIA TO GALLERY ---');
//     // console.log('Requested Media ID:', mediaId);
    
//     // Check if we have this stored
//     if (!this.originalGallerySources || !this.originalGallerySources.has(mediaId)) {
//       console.error('❌ NO STORED DATA for media ID:', mediaId);
//       // console.log('Available media IDs:', Array.from(this.originalGallerySources?.keys() || []));
//       return;
//     }
    
//     const storedData = this.originalGallerySources.get(mediaId);
//     // console.log('✓ Found stored data for media ID:', mediaId);
    
//     // Get current image state BEFORE restoration
//     const currentImg = storedData.imageElement;
//     if (currentImg) {
//       // console.log('Current image src:', currentImg.src.substring(0, 100) + '...');
//       // console.log('Will restore to:', storedData.src.substring(0, 100) + '...');
//     }
    
//     // Find the target item
//     const targetItem = storedData.itemElement;
    
//     if (!targetItem) {
//       console.error('❌ Target item element not found');
//       return;
//     }
    
//     // Update current index
//     const visibleIndex = this.visibleItems.indexOf(targetItem);
//     if (visibleIndex !== -1) {
//       this.currentIndex = visibleIndex;
//       // console.log('✓ Updated current index to:', this.currentIndex);
//     }
    
//     // RESTORE THE IMAGE
//     this.restoreImage(storedData);
    
//     // Update UI
//     this.updateViewerUI(targetItem);
//     this.updateThumbnails(mediaId);
//     this.updateControls();
//     this.announceChange(visibleIndex + 1);
    
//     // console.log('✓ GALLERY CHANGE COMPLETE\n');
//   }
  
//   /**
//    * Restore a single image
//    */
//   restoreImage(storedData) {
//     const img = storedData.imageElement;
    
//     if (!img || !img.parentNode) {
//       console.error('❌ Image element not in DOM');
//       return;
//     }
    
//     // console.log('Restoring image...');
    
//     // Force restore the src
//     if (storedData.src) {
//       img.src = storedData.src;
//       // console.log('  ✓ Set src');
//     }
    
//     if (storedData.srcset) {
//       img.srcset = storedData.srcset;
//       // console.log('  ✓ Set srcset');
//     }
    
//     if (storedData.dataSrc) {
//       img.setAttribute('data-src', storedData.dataSrc);
//       // console.log('  ✓ Set data-src');
//     }
    
//     // Force browser to reload
//     img.removeAttribute('loading');
    
//     // console.log('Image after restoration:', img.src.substring(0, 100) + '...');
//   }
  
//   /**
//    * Update viewer UI
//    */
//   updateViewerUI(targetItem) {
//     // Remove classes from all
//     this.viewerItems.forEach(item => {
//       item.classList.remove('is-current-variant', 'is-active');
//     });
    
//     // Add to target
//     targetItem.classList.add('is-current-variant');
    
//     if (this.layout === 'stacked') {
//       targetItem.classList.add('is-active');
      
//       if (this.dataset.stackedScroll === 'true') {
//         targetItem.scrollIntoView({ 
//           behavior: 'smooth', 
//           block: 'nearest' 
//         });
//       }
//     } else {
//       this.scrollToItem(targetItem);
//     }
//   }
  
//   /**
//    * Scroll to item
//    */
//   scrollToItem(targetItem) {
//     if (!this.viewer) return;
    
//     const itemIndex = Array.from(this.viewerItems).indexOf(targetItem);
//     const scrollLeft = itemIndex * this.viewer.offsetWidth;
    
//     // console.log('Scrolling to position:', scrollLeft);
    
//     this.viewer.scrollTo({
//       left: scrollLeft,
//       behavior: 'smooth'
//     });
//   }
  
//   /**
//    * Update thumbnails
//    */
//   updateThumbnails(mediaId) {
//     this.thumbnails.forEach(thumb => {
//       const thumbItem = thumb.closest('.media-thumbs__item');
//       const isActive = thumbItem && thumbItem.dataset.mediaId === mediaId;
      
//       thumb.classList.toggle('is-active', isActive);
//       thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
//     });
//   }
  
//   /**
//    * Update controls
//    */
//   updateControls() {
//     if (this.currentCounter) {
//       this.currentCounter.textContent = this.currentIndex + 1;
//     }
    
//     if (this.prevBtn) {
//       this.prevBtn.disabled = this.currentIndex === 0;
//     }
    
//     if (this.nextBtn) {
//       this.nextBtn.disabled = this.currentIndex >= this.visibleItems.length - 1;
//     }
//   }
  
//   /**
//    * Navigate previous
//    */
//   navigatePrev() {
//     if (this.currentIndex > 0) {
//       this.currentIndex--;
//       const targetItem = this.visibleItems[this.currentIndex];
//       const mediaId = targetItem.dataset.mediaId;
//       this.changeMediaToGallery(mediaId);
//     }
//   }
  
//   /**
//    * Navigate next
//    */
//   navigateNext() {
//     if (this.currentIndex < this.visibleItems.length - 1) {
//       this.currentIndex++;
//       const targetItem = this.visibleItems[this.currentIndex];
//       const mediaId = targetItem.dataset.mediaId;
//       this.changeMediaToGallery(mediaId);
//     }
//   }
  
//   /**
//    * Setup arrow clicks
//    */
//   setupArrowClicks() {
//     if (this.prevBtn) {
//       this.prevBtn.addEventListener('click', () => {
//         // console.log('\n⬅️ PREVIOUS ARROW CLICKED');
//         this.navigatePrev();
//       });
//     }
    
//     if (this.nextBtn) {
//       this.nextBtn.addEventListener('click', () => {
//         // console.log('\n➡️ NEXT ARROW CLICKED');
//         this.navigateNext();
//       });
//     }
//   }
  
//   /**
//    * Setup keyboard
//    */
//   setupKeyboardNavigation() {
//     if (this.viewer) {
//       this.viewer.addEventListener('keydown', (e) => {
//         if (e.key === 'ArrowLeft') {
//           e.preventDefault();
//           // console.log('\n⬅️ LEFT KEY PRESSED');
//           this.navigatePrev();
//         } else if (e.key === 'ArrowRight') {
//           e.preventDefault();
//           // console.log('\n➡️ RIGHT KEY PRESSED');
//           this.navigateNext();
//         }
//       });
//     }
//   }
  
//   /**
//    * Announce change
//    */
//   announceChange(position) {
//     const status = this.querySelector('.media-gallery__status');
//     if (status) {
//       const total = this.visibleItems.length;
//       status.textContent = `Viewing item ${position} of ${total}`;
//     }
//   }
  
//   /**
//    * Update active states
//    */
//   updateActiveStates() {
//     const currentItem = this.querySelector('.media-viewer__item.is-current-variant');
//     if (currentItem) {
//       const mediaId = currentItem.dataset.mediaId;
//       const visibleIndex = this.visibleItems.indexOf(currentItem);
//       if (visibleIndex !== -1) {
//         this.currentIndex = visibleIndex;
//       }
//       this.updateThumbnails(mediaId);
//       this.updateControls();
//     }
//   }
// }

// // Register
// if (!customElements.get('media-gallery')) {
//   customElements.define('media-gallery', MediaGallery);
//   // console.log('✓ MediaGallery registered');
// }

// // console.log('✓ Media Gallery DEBUG Script Loaded');


class MediaGallery extends HTMLElement {
  constructor() {
    super();
    
    this.viewer = this.querySelector('#gallery-viewer');
    this.thumbnails = this.querySelectorAll('.media-thumbs__btn');
    this.viewerItems = this.querySelectorAll('.media-viewer__item');
    this.prevBtn = this.querySelector('[name="prev"]');
    this.nextBtn = this.querySelector('[name="next"]');
    this.currentCounter = this.querySelector('.media-ctrl__current-item');
    this.layout = this.dataset.layout;
    
    this.currentIndex = 0;
    this.visibleItems = Array.from(this.viewerItems).filter(item => 
      !item.classList.contains('media-viewer__item--variant')
    );
    
    this.init();
  }
  
  init() {
    setTimeout(() => { this.storeOriginalImages(); }, 500);
    setTimeout(() => { this.setupInkyBayDetection(); }, 1000);
    
    this.setupThumbnailClicks();
    this.setupArrowClicks();
    this.setupKeyboardNavigation();
    this.updateActiveStates();
  }
  
  storeOriginalImages() {
    this.viewerItems.forEach((item) => {
      const mediaId = item.dataset.mediaId;
      const productImage = item.querySelector('img.product-image');
      if (productImage) {
        if (!this.originalGallerySources) this.originalGallerySources = new Map();
        this.originalGallerySources.set(mediaId, {
          itemElement: item,
          imageElement: productImage,
          src: productImage.getAttribute('src'),
          srcset: productImage.getAttribute('srcset'),
          dataSrc: productImage.getAttribute('data-src')
        });
      }
    });
  }
  
  setupInkyBayDetection() {
    const inkybayCard = document.querySelector('#INKYBAY_COLOR_CARD');
    if (inkybayCard) this.attachInkyBayListeners();
  }
  
  attachInkyBayListeners() {
    const colorSwatches = document.querySelectorAll('.inkybay_default_color_swatch_cover');
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {});
    });
  }
  
  setupThumbnailClicks() {
    this.thumbnails.forEach((thumb, index) => {
      const thumbItem = thumb.closest('.media-thumbs__item');
      const mediaId = thumbItem ? thumbItem.dataset.mediaId : 'UNKNOWN';
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        this.changeMediaToGallery(mediaId, index);
      });
    });
  }
  
  changeMediaToGallery(mediaId, thumbIndex = null) {
    if (!this.originalGallerySources || !this.originalGallerySources.has(mediaId)) {
      console.error('❌ NO STORED DATA for media ID:', mediaId);
      return;
    }
    const storedData = this.originalGallerySources.get(mediaId);
    const targetItem = storedData.itemElement;
    if (!targetItem) { console.error('❌ Target item element not found'); return; }
    
    const visibleIndex = this.visibleItems.indexOf(targetItem);
    if (visibleIndex !== -1) this.currentIndex = visibleIndex;
    
    this.restoreImage(storedData);
    this.updateViewerUI(targetItem);
    this.updateThumbnails(mediaId);
    this.updateControls();
    this.announceChange(visibleIndex + 1);
  }
  
  restoreImage(storedData) {
    const img = storedData.imageElement;
    if (!img || !img.parentNode) { console.error('❌ Image element not in DOM'); return; }
    if (storedData.src)     img.src = storedData.src;
    if (storedData.srcset)  img.srcset = storedData.srcset;
    if (storedData.dataSrc) img.setAttribute('data-src', storedData.dataSrc);
    img.removeAttribute('loading');
  }
  
  updateViewerUI(targetItem) {
    this.viewerItems.forEach(item => item.classList.remove('is-current-variant', 'is-active'));
    targetItem.classList.add('is-current-variant');
    if (this.layout === 'stacked') {
      targetItem.classList.add('is-active');
      if (this.dataset.stackedScroll === 'true') {
        targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    } else {
      this.scrollToItem(targetItem);
    }
  }

  // DESKTOP scroll — index based
  scrollToItem(targetItem) {
    if (!this.viewer) return;
    const itemIndex = Array.from(this.viewerItems).indexOf(targetItem);
    const scrollLeft = itemIndex * this.viewer.offsetWidth;
    this.viewer.scrollTo({ left: scrollLeft, behavior: 'smooth' });
  }
  
  updateThumbnails(mediaId) {
    this.thumbnails.forEach(thumb => {
      const thumbItem = thumb.closest('.media-thumbs__item');
      const isActive = thumbItem && thumbItem.dataset.mediaId === mediaId;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
  
  updateControls() {
    if (this.currentCounter) this.currentCounter.textContent = this.currentIndex + 1;
    if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.visibleItems.length - 1;
  }
  
  navigatePrev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.changeMediaToGallery(this.visibleItems[this.currentIndex].dataset.mediaId);
    }
  }
  
  navigateNext() {
    if (this.currentIndex < this.visibleItems.length - 1) {
      this.currentIndex++;
      this.changeMediaToGallery(this.visibleItems[this.currentIndex].dataset.mediaId);
    }
  }
  
  // DESKTOP arrow clicks
  setupArrowClicks() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.navigatePrev(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.navigateNext(); });
  }
  
  setupKeyboardNavigation() {
    if (this.viewer) {
      this.viewer.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.navigatePrev(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.navigateNext(); }
      });
    }
  }
  
  announceChange(position) {
    const status = this.querySelector('.media-gallery__status');
    if (status) status.textContent = `Viewing item ${position} of ${this.visibleItems.length}`;
  }
  
  updateActiveStates() {
    const currentItem = this.querySelector('.media-viewer__item.is-current-variant');
    if (currentItem) {
      const mediaId = currentItem.dataset.mediaId;
      const visibleIndex = this.visibleItems.indexOf(currentItem);
      if (visibleIndex !== -1) this.currentIndex = visibleIndex;
      this.updateThumbnails(mediaId);
      this.updateControls();
    }
  }


  // ============================================================
  // MOBILE SUPPORT
  // All desktop code above is completely untouched.
  // ============================================================

  setGalleryMode(active) {
    this._galleryModeActive = active;
  }

  hideInkybayOverlayPermanently() {
    this.removeInkybayOverrideStyle();
    const style = document.createElement('style');
    style.id = 'gallery-inkybay-override';
    style.textContent = `
      #INKYBAY_PREVIEW_IMAGE,
      #INKYBAY_PREVIEW_CANVAS,
      #INKYBAY_MAIN_PREVIEW,
      #EFOLI_PREVIEW_IMAGE,
      #EFOLI_PREVIEW_CANVAS,
      [id^="INKYBAY_PREVIEW"],
      [id^="EFOLI_PREVIEW"],
      .inkybay-preview,
      .inkybay_preview,
      .inkybay-overlay,
      [class*="inkybay-preview"],
      [class*="inkybay_preview"] {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }
    `;
    document.head.appendChild(style);

    const activeItem = this.querySelector('.media-viewer__item.is-current-variant');
    if (activeItem) {
      activeItem.querySelectorAll('canvas').forEach(canvas => {
        canvas.setAttribute('data-gallery-hidden', 'true');
        canvas.style.setProperty('display', 'none', 'important');
        canvas.style.setProperty('opacity', '0', 'important');
      });
      const productImage = activeItem.querySelector('img.product-image');
      activeItem.querySelectorAll('img').forEach(img => {
        if (img !== productImage) {
          img.setAttribute('data-gallery-hidden', 'true');
          img.style.setProperty('display', 'none', 'important');
          img.style.setProperty('opacity', '0', 'important');
        }
      });
    }
  }

  /**
   * Remove override style ONLY after InkyBay has fully rendered its color image.
   *
   * The flash problem:
   *   Old approach → remove style immediately on swatch tap
   *   Result       → overlay becomes visible instantly but InkyBay hasn't
   *                  rendered yet, so you see a blank flash for ~100-300ms
   *
   * New approach:
   *   1. Keep the override style active (overlay stays hidden)
   *   2. Watch for InkyBay to inject/update its overlay element via MutationObserver
   *   3. Once InkyBay's image is loaded and ready, THEN remove the override style
   *   4. Fallback: if InkyBay doesn't update the DOM within 1s, remove anyway
   *
   * This means the overlay only becomes visible at the exact moment InkyBay's
   * color image is ready — no flash.
   */
  removeInkybayOverrideStyleWhenReady() {
    // Cancel any previous pending removal
    if (this._swatchObserver) {
      this._swatchObserver.disconnect();
      this._swatchObserver = null;
    }
    if (this._swatchFallbackTimer) {
      clearTimeout(this._swatchFallbackTimer);
      this._swatchFallbackTimer = null;
    }

    const doRemove = () => {
      if (this._swatchObserver) {
        this._swatchObserver.disconnect();
        this._swatchObserver = null;
      }
      if (this._swatchFallbackTimer) {
        clearTimeout(this._swatchFallbackTimer);
        this._swatchFallbackTimer = null;
      }

      // Remove the blocking style tag
      const existing = document.getElementById('gallery-inkybay-override');
      if (existing) existing.remove();

      // Restore individually hidden elements
      document.querySelectorAll('[data-gallery-hidden="true"]').forEach(el => {
        el.removeAttribute('data-gallery-hidden');
        el.style.removeProperty('display');
        el.style.removeProperty('opacity');
      });
    };

    // Known InkyBay overlay selectors to watch for changes
    const overlaySelectors = [
      '#INKYBAY_PREVIEW_IMAGE',
      '#INKYBAY_PREVIEW_CANVAS',
      '#INKYBAY_MAIN_PREVIEW',
      '#EFOLI_PREVIEW_IMAGE',
      '#EFOLI_PREVIEW_CANVAS'
    ];

    // Find whichever overlay element InkyBay uses on this store
    let overlayEl = null;
    for (const sel of overlaySelectors) {
      overlayEl = document.querySelector(sel);
      if (overlayEl) break;
    }

    if (overlayEl) {
      // Watch for InkyBay to update the overlay element's src/style/children
      // which signals it has finished rendering the new color
      this._swatchObserver = new MutationObserver((mutations) => {
        // Check if any meaningful change happened (src change, style change, child added)
        const meaningful = mutations.some(m =>
          m.type === 'attributes' ||
          m.type === 'childList' ||
          (m.type === 'characterData')
        );
        if (meaningful) {
          // Give InkyBay one extra frame to finish painting before we reveal
          requestAnimationFrame(() => {
            requestAnimationFrame(doRemove);
          });
        }
      });

      this._swatchObserver.observe(overlayEl, {
        attributes: true,        // catches src, style changes
        childList: true,         // catches injected child elements
        subtree: true,           // catches nested changes
        attributeFilter: ['src', 'style', 'class']
      });

      // Also watch the overlay's parent container in case InkyBay
      // replaces the whole element rather than modifying it
      if (overlayEl.parentElement) {
        this._swatchObserver.observe(overlayEl.parentElement, {
          childList: true,
          subtree: false
        });
      }
    }

    // Fallback: if InkyBay doesn't trigger the observer within 1s, remove anyway
    // This handles edge cases where InkyBay uses a method we didn't anticipate
    this._swatchFallbackTimer = setTimeout(doRemove, 1000);
  }

  removeInkybayOverrideStyle() {
    const existing = document.getElementById('gallery-inkybay-override');
    if (existing) existing.remove();
    document.querySelectorAll('[data-gallery-hidden="true"]').forEach(el => {
      el.removeAttribute('data-gallery-hidden');
      el.style.removeProperty('display');
      el.style.removeProperty('opacity');
    });
  }

  // MOBILE scroll — offsetLeft based
  scrollToItemMobile(targetItem) {
    if (!this.viewer) return;
    this.viewer.scrollTo({ left: targetItem.offsetLeft, behavior: 'smooth' });
  }

  // Core mobile navigation used by thumbnail tap, arrow tap, and swipe
  mobileNavigateTo(mediaId) {
    if (!this.originalGallerySources || !this.originalGallerySources.has(mediaId)) return;
    const storedData = this.originalGallerySources.get(mediaId);
    const targetItem = storedData.itemElement;
    if (!targetItem) return;

    const visibleIndex = this.visibleItems.indexOf(targetItem);
    if (visibleIndex !== -1) this.currentIndex = visibleIndex;

    this.restoreImage(storedData);
    this.scrollToItemMobile(targetItem);

    this.viewerItems.forEach(item => item.classList.remove('is-current-variant', 'is-active'));
    targetItem.classList.add('is-current-variant');
    this.updateThumbnails(mediaId);
    this.updateControls();
    this.announceChange(visibleIndex + 1);

    this.setGalleryMode(true);
    this.hideInkybayOverlayPermanently();
  }

  // Mobile thumbnail taps
  setupMobileThumbnailTouch() {
    this.thumbnails.forEach((thumb) => {
      const thumbItem = thumb.closest('.media-thumbs__item');
      const mediaId = thumbItem ? thumbItem.dataset.mediaId : 'UNKNOWN';
      let touchMoved = false;

      thumb.addEventListener('touchstart', () => { touchMoved = false; }, { passive: true });
      thumb.addEventListener('touchmove', () => { touchMoved = true; }, { passive: true });
      thumb.addEventListener('touchend', (e) => {
        if (!touchMoved) {
          e.preventDefault();
          e.stopPropagation();
          this.mobileNavigateTo(mediaId);
        }
      });
    });
  }

  // Mobile arrow taps
  setupMobileArrowClicks() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('touchend', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.mobileNavigateTo(this.visibleItems[this.currentIndex].dataset.mediaId);
        }
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('touchend', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.currentIndex < this.visibleItems.length - 1) {
          this.currentIndex++;
          this.mobileNavigateTo(this.visibleItems[this.currentIndex].dataset.mediaId);
        }
      });
    }
  }

  // Mobile swipe — listens on outer element to avoid scroll container conflict
  setupTouchNavigation() {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartTarget = null;

    this.addEventListener('touchstart', (e) => {
      // Only track swipes that start inside the main viewer image area
      if (!e.target.closest('#gallery-viewer') && !e.target.closest('.media-viewer') && !e.target.closest('.media-gallery__viewer')) {
        touchStartX = 0; touchStartY = 0; touchStartTarget = null; return;
      }
      const touch = e.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchStartTarget = e.target;
    }, { passive: true });

    this.addEventListener('touchend', (e) => {
      // Bail if touch didn't start in the viewer area
      if (!touchStartTarget) return;

      // Ignore touches on thumbnails and arrow buttons
      if (
        touchStartTarget.closest('.media-thumbs__item') ||
        touchStartTarget.closest('[name="prev"]') ||
        touchStartTarget.closest('[name="next"]') ||
        touchStartTarget.closest('.media-thumbs')
      ) return;

      const touch = e.changedTouches[0];
      const diffX = touchStartX - touch.clientX;
      const diffY = Math.abs(touchStartY - touch.clientY);
      const isHorizontalSwipe = Math.abs(diffX) > 50 && diffY < Math.abs(diffX) && diffY < 80;

      if (!isHorizontalSwipe) return;

      // Calculate next index before mutating this.currentIndex
      let nextIndex = this.currentIndex;
      if (diffX > 0 && this.currentIndex < this.visibleItems.length - 1) {
        nextIndex = this.currentIndex + 1;
      } else if (diffX < 0 && this.currentIndex > 0) {
        nextIndex = this.currentIndex - 1;
      } else {
        return;
      }

      // mobileNavigateTo handles image restore, correct scroll, UI update,
      // and InkyBay overlay hide — identical behaviour to arrows and thumbnails
      this.mobileNavigateTo(this.visibleItems[nextIndex].dataset.mediaId);

      // Reset so a stray touchend doesn't fire twice
      touchStartTarget = null;
    }, { passive: true });
  }

  // InkyBay color swatch taps
  setupInkybaySwatchTouchListeners() {
    const attachToSwatches = () => {
      document.querySelectorAll('.inkybay_default_color_swatch_cover').forEach(swatch => {
        if (swatch._galleryListenerAttached) return;
        swatch._galleryListenerAttached = true;

        const onSwatchActivated = () => {
          this.setGalleryMode(false);
          // Wait for InkyBay to finish rendering before revealing overlay
          // This eliminates the flash of unrendered content
          this.removeInkybayOverrideStyleWhenReady();
        };

        swatch.addEventListener('touchend', onSwatchActivated, { passive: true });
        swatch.addEventListener('click', onSwatchActivated);
      });
    };

    attachToSwatches();
    setTimeout(attachToSwatches, 500);
    setTimeout(attachToSwatches, 1500);

    const observer = new MutationObserver(attachToSwatches);
    observer.observe(document.body, { childList: true, subtree: true });
  }

}

// Register custom element
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}

// ============================================================
// MOBILE INIT
// ============================================================
document.addEventListener('DOMContentLoaded', () => {
  function initMobileGallery(gallery) {
    if (gallery._mobileInitDone) return;
    gallery._mobileInitDone = true;

    gallery.setupMobileThumbnailTouch();
    gallery.setupMobileArrowClicks();
    gallery.setupTouchNavigation();
    gallery.setupInkybaySwatchTouchListeners();
  }

  document.querySelectorAll('media-gallery').forEach(initMobileGallery);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.tagName === 'MEDIA-GALLERY') initMobileGallery(node);
        if (node.querySelectorAll) {
          node.querySelectorAll('media-gallery').forEach(initMobileGallery);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// console.log('✓ Media Gallery Script Loaded');